import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL, LabelL } from '@sorare/core/src/atoms/typography';
import { OnboardingButton } from '@sorare/core/src/components/onboarding/OnboardingButton';
import {
  FOOTBALL_ONBOARDING_TUTORIAL_RECRUIT,
  FOOTBALL_ONBOARDING_TUTORIAL_WIN,
} from '@sorare/core/src/constants/__generated__/routes';
import { glossary } from '@sorare/core/src/lib/glossary';

import { MarketGuidanceLayout } from '#src/components/onboarding/MarketGuidanceLayout/index.tsx';
import { PlayLineupAnimation } from '#src/components/onboarding/PlayLineupAnimation/index.tsx';
import { ConversionCredit } from '#src/pages/onboarding_/tutorial/ConversionCredit/index.tsx';

const Root = styled(Vertical).attrs({ gap: 2 })`
  justify-content: space-between;
  flex: 1;
`;

const StyledFooter = styled(Vertical)`
  position: sticky;
  bottom: var(--double-unit);
  align-self: center;
`;

const TutorialPlayPage = () => {
  return (
    <MarketGuidanceLayout
      progress={3}
      center
      backUrl={FOOTBALL_ONBOARDING_TUTORIAL_RECRUIT}
    >
      <Root>
        <Vertical gap={1.5} center>
          <FormattedMessage
            defaultMessage="<em>Play</em><label>with lineups of 5 players</label>"
            values={{
              em: chunks => <BrandL>{chunks}</BrandL>,
              label: chunks => <LabelL>{chunks}</LabelL>,
            }}
          />
        </Vertical>
        <PlayLineupAnimation />
        <StyledFooter gap={0}>
          <ConversionCredit />
          <OnboardingButton
            size="large"
            color="secondary"
            to={FOOTBALL_ONBOARDING_TUTORIAL_WIN}
            prefetch="render"
          >
            <FormattedMessage {...glossary.continue} />
          </OnboardingButton>
        </StyledFooter>
      </Root>
    </MarketGuidanceLayout>
  );
};
export default TutorialPlayPage;
